<div class="card-group gap-3">
  <div class="card rounded border-0">
    <img
      src="../../../../../assets/images/lookup-user-icon.png"
      class="card-img-top card-img-size"
      alt="..."
    />
    <div class="card-body">
      <h5 class="card-title">Lookup Users</h5>
      <p class="card-text">Easily and quickly find the user you want.</p>
      <br />
      <p class="card-text">
        <small class="text-muted"
          >The average execution time is 1 minute.</small
        >
      </p>
    </div>
  </div>
  <div class="card rounded border-0">
    <img
      src="../../../../../assets/images/create-user-icon.png"
      class="card-img-center card-img-size"
      alt="..."
    />
    <div class="card-body">
      <h5 class="card-title">Create Users</h5>
      <p class="card-text">Fill out a simple form and add a new user.</p>
      <br />
      <p class="card-text">
        <small class="text-muted"
          >The average execution time is 2 minutes.</small
        >
      </p>
    </div>
  </div>
  <div class="card rounded border-0">
    <img
      src="../../../../../assets/images/update-user-icon.png"
      class="card-img-top card-img-size"
    />
    <div class="card-body">
      <h5 class="card-title">Update Users</h5>
      <p class="card-text">
        Find the user whose information you want to update and update them
        quickly and easily.
      </p>
      <p class="card-text">
        <small class="text-muted"
          >The average execution time is 2 minutes.</small
        >
      </p>
    </div>
  </div>
  <div class="card rounded border-0">
    <img
      src="../../../../../assets/images/delete-user-icon.png"
      class="card-img-center card-img-size"
      alt="..."
    />
    <div class="card-body">
      <h5 class="card-title">Delete Users</h5>
      <p class="card-text">
        Find the user you want to delete and delete them with one click.
      </p>
      <br />
      <p class="card-text">
        <small class="text-muted"
          >The average execution time is 1 minute.</small
        >
      </p>
    </div>
  </div>
</div>
